
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefit/hwajang/[companyname]",
      function () {
        return require("private-next-pages/benefit/hwajang/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefit/hwajang/[companyname]"])
      });
    }
  